var map = {
	"./music-instructions.json": 4363,
	"./music-library-intro2024.json": 4364,
	"./music-library-launch2024.json": 4365,
	"./music-progression.json": 4366,
	"./startSourcesAdvanced.json": 4367,
	"./startSourcesSimple.json": 4368,
	"./startSourcesSimple2.json": 4369,
	"./startSourcesTracks.json": 4370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4100;